import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-text-selection-popover';
import Fade from '@material-ui/core/Fade';
import { useParams, useHistory } from 'react-router-dom';

import EncounterCard from '../encountercard/components/encountercard';
import Lookback from '../lookback/components/lookback';
import AddReasonOptionDialog from '../addreasonoptiondialog/addreasonoptiondialog';
import AddDxDialog from '../adddxdialog/components/adddxdialog';
import LoadingDialog from '../loadingdialog/components/loadingdialog';
import TextSelectionMenu from '../textselectionmenu/textselectionmenu';
import useBroadcastChannel from './usebroadcastchannel';
import usePopoutCard from '../../modules/hooks/popoutcard/hook';

const rootStyle = {
  height: '100%'
};

const headerStyle = {
  color: '#fff',
  backgroundColor: '#303f9f',
  height: '33px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 0.35em'
};

const notesAreaRef = React.createRef();

const pluckMessage = original => original.data;

const PopoutCard = props => {
  const { service } = props;
  const { encounterId } = useParams();
  const [state, boundActions] = usePopoutCard(service, encounterId);

  const broadcastHandler = channel => e => {
    const message = pluckMessage(e);

    switch (message.type) {
      case 'SHOW_LOADING': {
        const { payload: { statusMessage } } = message;
        boundActions.showLoading(statusMessage);
        return;
      }

      case 'HIDE_LOADING': {
        boundActions.hideLoading();
        return;
      }

      case 'CLOSE_ADD_DX_DIALOG': {
        boundActions.closeAddDxDialog();
        return;
      }

      case 'RELOAD_ENCOUNTER': {
        const { payload : { encounterId } } = message;
        boundActions.reloadEncounter(encounterId).then(e => {
          boundActions.hideLoading();
          channel.postMessage({ type: 'UPDATE_POPOUT_STATE' });
        });
      }

      default: {
        return;
      }
    }
  };

  const [postMessage] = useBroadcastChannel('foo', broadcastHandler);

  const { lookback } = state;

  useEffect(() => { props.hideNav(); }, []);

  const doAddDx = (encounterId, cmsCodeId, supportingText, reasonOptions) => {
    postMessage({
      type: 'ADD_DX',
      payload: {
        encounterId,
        cmsCodeId,
        supportingText,
        reasonOptions
      }
    });
  };

  return (
    <div style={rootStyle}>
      <Popover selectionRef={notesAreaRef}>
        <TextSelectionMenu
          openAddDxDialog={boundActions.openAddDxDialog}
          dateOfService={state.details.dateOfService}
        />
      </Popover>

      <div style={headerStyle}>
        <div>
          <label>
            {
              lookback.isVisible
                ? 'Encounter List'
                : 'Notes'
            }
          </label>
        </div>

        {/* button area */}
        <div>
          <button
            onClick={() =>
              lookback.isVisible
                ? boundActions.hideLookback()
                : boundActions.showLookback()
            }
          >
            <span>
              {
                lookback.isVisible ? 'Show Notes' : 'Show Encounter List'
              }
            </span>
          </button>
        </div>
      </div>

      <div>
          {/* Lookback */}
          <Fade in={lookback.isVisible}>
            <div style={{ display: lookback.isVisible ? 'block' : 'none' }}>
              <Lookback
                encounterList={state.details.encounterList}
                dxFilterValue={lookback.dxFilterValue}
                hccFilterValue={lookback.hccFilterValue}
                handleLookbackFilterChange={boundActions.setLookbackFilterValue}
                redirectToReviewDetails={boundActions.redirectToReviewDetails}
              />
            </div>
          </Fade>

          {/* EncounterCard */}
          <Fade in={!lookback.isVisible}>
            <div style={{ display: !lookback.isVisible ? 'block' : 'none' }}>
              <EncounterCard
                noteMarkup={state.details.encounterCard.encounterText}
                forwardRef={notesAreaRef}
                dateOfService={state.details.dateOfService}
              />
            </div>
          </Fade>
        </div>

      <LoadingDialog
        isOpen={state.isLoading}
        loadingMessage={state.statusMessage}
      />

      <AddDxDialog
        isOpen={state.addDxDialog.isOpen}
        dateOfService={state.details.dateOfService}
        encounterId={encounterId}
        supportingText={state.addDxDialog.supportingText}
        reasonOptions={state.details.reasonOptions}
        addDx={doAddDx}
        closeDialog={boundActions.closeAddDxDialog}
        isPoppedOut={true}
      />
    </div>
  );
};

PopoutCard.propTypes = {
  service: PropTypes.object.isRequired
};

export default PopoutCard;
